module.exports = __webpack_public_path__ + "static/media/ico-add.f8f38126.svg";